import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Cell, Tooltip } from 'recharts';

const AcresImpactChart = ({ yourInvestment = 10, pathwayTarget = 100 }) => {
  const data = [
    { name: 'Your Investment', value: yourInvestment, color: '#FFFFFF' },
    { name: 'Pathway Target', value: pathwayTarget, color: '#0066CC' }
  ];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white px-3 py-2 border border-gray-200 rounded shadow-lg">
          <p className="text-sm font-medium text-gray-900">{payload[0].payload.name}</p>
          <p className="text-sm text-gray-600">{`${payload[0].value} acres`}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="w-full flex items-center flex-col">
      <div className="text-[#424242] font-sora text-[.875rem] font-[400] leading-[1.5rem]">
     Acres Impact
      </div>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          data={data}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
          <XAxis
            dataKey="name"
            angle={0}
            textAnchor="middle"
            height={60}
            tick={{ fontSize: 12, fill: '#666' }}
          />
          <YAxis
            tick={{ fontSize: 12, fill: '#666' }}
          />
          <Bar dataKey="value" barSize={80} cursor="default">
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={entry.color}
                stroke="#0066CC"
                strokeWidth={2}
              />
            ))}
          </Bar>
          <Tooltip content={<CustomTooltip />} cursor={false} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AcresImpactChart;
